import {
  fetchChatsGetUnreadChatsDesktop,
  IChatsGetUnreadChatsDesktopRequest,
  TChatsGetUnreadChatsDesktopResponse,
} from '../repositories/chats/v1/chats/get-unread-chats-desktop';
import { TContext } from '../types/context';

type TFetchArchivedChatsParams = {
  parameters: IChatsGetUnreadChatsDesktopRequest;
  cookies?: string;
};

export async function fetchUnreadChats(
  { logger, httpApi }: TContext,
  { cookies, parameters }: TFetchArchivedChatsParams,
) {
  try {
    const { response, statusCode }: TChatsGetUnreadChatsDesktopResponse = await fetchChatsGetUnreadChatsDesktop({
      httpApi,
      parameters,
      config: {
        requestConfig: {
          headers: cookies ? [['Cookie', cookies]] : [],
          withCredentials: true,
        },
      },
    });

    if (statusCode !== 200) {
      return null;
    }

    return response.chats;
  } catch (error) {
    logger.error(error, {
      domain: 'src/shared/services/fetchUnreadChats.ts [fetchUnreadChats]',
      message: 'Не удалось получить список непрочитанных чатов',
    });

    return null;
  }
}
